/*
* Pipeline Theme — Custom JS
*
* Mia & Mila — Custom Product Add-ons
* ------------------------------------
* 1. ADD: When a product has add-on checkboxes ([data-product-addons]) and at
*    least one is checked, we take over the Add-to-Cart click and add the parent
*    product + every checked add-on in ONE /cart/add.js request. A unique
*    `_group_id` line-item property links them. The add-on also carries a
*    readable `Add-on for` property so the order/admin shows the parent.
* 2. SYNC: When the cart changes, add-on quantities are kept in lock-step with
*    their parent, and add-ons are removed when their parent is removed.
*
* Line item property rules used here:
*   _group_id  -> hidden from customer, visible to admin   (links the pair)
*   _role      -> hidden ("parent" | "addon")
*   Add-on for -> visible to customer + admin               (the human clue)
*/

(function () {
  'use strict';

  var ADDONS = '[data-product-addons]';
  var ADD_BTN = '[data-add-to-cart]';

  function cartRoot() {
    return (window.theme && theme.routes && theme.routes.cart) ? theme.routes.cart : '/cart';
  }

  function getProductJSON(form) {
    var scope = form.closest('product-form') || form.closest('[data-section-id]') || document;
    var el = scope.querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function findVariant(form, id) {
    var p = getProductJSON(form);
    if (!p || !p.variants) return null;
    id = String(id);
    for (var i = 0; i < p.variants.length; i++) {
      if (String(p.variants[i].id) === id) return p.variants[i];
    }
    return null;
  }

  // Readable "Berry Swirl (1-2)" style label for the add-on's `Add-on for`
  function buildParentLabel(form, id) {
    var p = getProductJSON(form);
    var v = findVariant(form, id);
    var title = (p && p.title) ? p.title : (document.title || '').trim();
    if (v && v.title && v.title.indexOf('Default') === -1) {
      return title + ' (' + v.title + ')';
    }
    return title;
  }

  function setBtnLoading(btn) {
    if (!btn) return;
    btn.classList.add('loading');
    btn.setAttribute('disabled', 'disabled');
  }
  function setBtnSuccess(btn) {
    if (!btn) return;
    btn.classList.remove('loading');
    btn.classList.add('has-success');
    setTimeout(function () {
      btn.classList.remove('has-success');
      btn.removeAttribute('disabled');
    }, 3500);
  }
  function setBtnIdle(btn) {
    if (!btn) return;
    btn.classList.remove('loading');
    btn.removeAttribute('disabled');
  }

  /* =============================================================
   * 1. ADD TO CART — intercept (capture phase, before theme handler)
   * ============================================================= */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(ADD_BTN);
    if (!btn) return;

    var form = btn.closest('form[action*="/cart/add"], form[data-product-form]');
    if (!form) return;

    var wrap = form.querySelector(ADDONS);
    if (!wrap) return; // product has no add-ons -> let the theme add normally

    var checked = wrap.querySelectorAll('[data-addon-checkbox]:checked');
    if (!checked.length) return; // no add-on selected -> normal single add

    // We are taking over: stop the theme's own click handler.
    e.preventDefault();
    e.stopImmediatePropagation();

    addWithAddons(form, btn, checked);
  }, true);

  function addWithAddons(form, btn, checked) {
    var idInput = form.querySelector('[name="id"]');
    var parentVariantId = idInput && idInput.value;
    if (!parentVariantId) { return; }

    setBtnLoading(btn);

    // Gather any existing visible/hidden properties[...] on the form (e.g. Pre-order)
    var parentProps = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (inp) {
      if ((inp.type === 'checkbox' || inp.type === 'radio') && !inp.checked) return;
      var m = inp.name.match(/^properties\[(.+)\]$/);
      if (m && inp.value) parentProps[m[1]] = inp.value;
    });

    var groupId = Date.now() + '-' + Math.random().toString(36).slice(2, 8);
    var parentLabel = buildParentLabel(form, parentVariantId);

    var titles = [];
    checked.forEach(function (c) { titles.push(c.getAttribute('data-addon-title')); });

    parentProps._group_id = groupId;
    parentProps._role = 'parent';
    parentProps['Customisation'] = titles.join(', ');

    var items = [{ id: parentVariantId, quantity: 1, properties: parentProps }];
    checked.forEach(function (c) {
      items.push({
        id: c.getAttribute('data-addon-variant-id'),
        quantity: 1,
        properties: {
          _group_id: groupId,
          _role: 'addon',
          'Add-on for': parentLabel
        }
      });
    });

    fetch(cartRoot() + '/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function () {
        return fetch(cartRoot() + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        // Header count update
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));

        // Show the same confirmation popdown the theme normally shows for the parent
        var variant = findVariant(form, parentVariantId);
        if (variant) {
          document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { variant: variant }, bubbles: true }));
        }
        // Refresh the cart drawer contents so the nested add-on shows
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));

        // Reset checkboxes for the next add
        checked.forEach(function (c) { c.checked = false; });
        setBtnSuccess(btn);
      })
      .catch(function (err) {
        console.error('[mm-addons] add failed', err);
        setBtnIdle(btn);
        var msg = (err && err.description) ? err.description : 'Could not add to cart. Please try again.';
        window.alert(msg);
      });
  }

  /* =============================================================
   * 2. CART SYNC — keep add-on qty == parent qty; remove orphans
   * ============================================================= */
  var syncing = false;

  document.addEventListener('theme:cart:change', function (e) {
    if (syncing) return;
    var cart = e.detail && e.detail.cart;
    if (!cart || !cart.items) return;
    syncAddons(cart);
  });

  function syncAddons(cart) {
    // Map group_id -> parent quantity
    var parentQty = {};
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._role === 'parent' && p._group_id) parentQty[p._group_id] = it.quantity;
    });

    var changes = []; // { key, qty }
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._role !== 'addon' || !p._group_id) return;
      var pq = parentQty[p._group_id];
      if (pq === undefined) {
        // parent is gone -> drop the add-on
        if (it.quantity !== 0) changes.push({ key: it.key, qty: 0 });
      } else if (it.quantity !== pq) {
        changes.push({ key: it.key, qty: pq });
      }
    });

    if (!changes.length) return;

    syncing = true;
    var chain = Promise.resolve();
    changes.forEach(function (c) {
      chain = chain.then(function () {
        return fetch(cartRoot() + '/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: c.key, quantity: c.qty })
        });
      });
    });

    chain
      .then(function () {
        return fetch(cartRoot() + '.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); });
      })
      .then(function (fresh) {
        // Update the theme's cached cart (syncing flag keeps us from re-triggering)
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: fresh }, bubbles: true }));
        syncing = false;
        document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function (err) {
        syncing = false;
        console.error('[mm-addons] sync failed', err);
      });
  }
})();
